import { render, staticRenderFns } from "./unloadPage.vue?vue&type=template&id=a35488a6&scoped=true&"
import script from "./unloadPage.vue?vue&type=script&lang=js&"
export * from "./unloadPage.vue?vue&type=script&lang=js&"
import style0 from "./unloadPage.vue?vue&type=style&index=0&id=a35488a6&scoped=true&lang=css&"
import style1 from "./unloadPage.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a35488a6",
  null
  
)

export default component.exports